<template lang="pug">
AppNav.clients-view-selector
  li.clients-nav--active(:class="{ active: activeView }")
    a(
      href="#"
      @click.prevent="setStatus('active')"
    )
      | Active ({{ activeClientsCount }})
  li.clients-nav--archived(:class="{ active: archivedView }")
    a(
      href="#"
      @click.prevent="setStatus('archived')"
    )
      | Archived ({{ archivedClientsCount }})
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ClientsViewSelector',
  computed: {
    ...mapGetters(['activeView', 'archivedView', 'activeClientsCount', 'archivedClientsCount']),
  },
  methods: {
    ...mapActions(['setStatus']),
  },
};
</script>
